import { useCallback, useMemo, useRef, useState } from 'react'

import {
  applyFaqApiResponse,
  createFaqListHandlers,
  normalizeFaqList,
} from '../utils/faqUtils'

/**
 * FAQ section state + handlers for entity edit/create pages.
 * @param {() => void} [onDirty] called when FAQ data changes
 */
export default function useFaqSectionState(onDirty) {
  const [faqAbilitato, setFaqAbilitato] = useState(false)
  const [faqList, setFaqList] = useState([])
  const onDirtyRef = useRef(onDirty)
  onDirtyRef.current = onDirty

  const handlers = useMemo(
    () =>
      createFaqListHandlers({
        setFaqList,
        setFaqAbilitato,
        onDirty: () => onDirtyRef.current?.(),
      }),
    []
  )

  const applyFromApi = useCallback((data) => {
    const { faq_abilitato, faq } = applyFaqApiResponse(data)
    setFaqAbilitato(faq_abilitato)
    setFaqList(faq)
  }, [])

  const resetFaq = useCallback(() => {
    setFaqAbilitato(false)
    setFaqList([])
  }, [])

  const loadFromCopia = useCallback((copia) => {
    if (!copia) return
    if (copia.faqAbilitato !== undefined) setFaqAbilitato(copia.faqAbilitato)
    if (copia.faqList) {
      setFaqList(normalizeFaqList(copia.faqList))
      if (copia.faqList.length > 0 && copia.faqAbilitato === undefined) {
        setFaqAbilitato(true)
      }
    }
  }, [])

  return {
    faqAbilitato,
    faqList,
    setFaqAbilitato,
    setFaqList,
    applyFromApi,
    resetFaq,
    loadFromCopia,
    ...handlers,
  }
}
